export default __webpack_public_path__ + "static/media/frente-casa4.f4ff9e73.jpg";